import React from 'react';
import { Tabs as BootstrapTabs, Tab } from 'react-bootstrap';

const Tabs = ({ 
    items = [], 
    defaultActiveKey,
    variant = 'tabs',
    fill = false,
    justify = false,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapTabs 
            defaultActiveKey={defaultActiveKey || (items[0] && (items[0].key || '0'))}
            variant={variant}
            fill={fill}
            justify={justify}
            className={className} 
            style={style}
            {...props}
        >
            {items.map((item, index) => (
                <Tab 
                    key={index}
                    eventKey={item.key || index.toString()} 
                    title={item.title || item.label}
                    disabled={item.disabled}
                >
                    {item.content || item.children}
                </Tab>
            ))}
        </BootstrapTabs>
    );
};

export default Tabs;

